import React, { useState, useEffect } from 'react';
import { getPurchaseOrderRequest, getPurchaseOrderById, editPurchaseOrder, deletePurchaseOrder } from '../../services/mm/apiController';
import { useSelector } from 'react-redux';
import { factoryId, loggedInUser } from '../../store/reducers/account_reducer';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col, Alert } from 'react-bootstrap';
import { formatDate } from '../../util/helper';
import { toast, ToastContainer } from 'react-toastify';
import { DeleteIcon, EditIcon, ViewIcon } from '../vm/components/icons';
import { Link } from 'react-router-dom';
import { getStoredData, get_auth_key } from '../../util';
import moment from 'moment';
import useDebounce from '../useDebounce';
import 'react-toastify/dist/ReactToastify.css';
import AlertIcon from '../../img.svg';
import FactoryDropdown from '../vm/FactoryDropdown';
import PaginationInPage from '../Pagination';
import axios from 'axios';

const PurchaseOrderView = () => {
  let user = useSelector(loggedInUser);
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [machineNameSearch, setMachineNameSearch] = useState('');
  const [poNumber, setPoNumber] = useState('');
  const [idToDeleted, setIdToDeleted] = useState('');
  const [machineIdToDeleted, setMachineIdToDeleted] = useState('');
  const [purchaseOrderList, setPurchaseOrderList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const factoryId_ = useSelector(factoryId);

  const formFields = {
    poNumber: '',
    item: '',
    amount: '',
    approvedDate: '',
    initiatedBy: '',
    file1: '',
    file_1: '',
    file2: '',
    file_2: '',
    file3: '',
    file_3: '',
    factoryId: factoryId_,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };
  const [purchaseOrderForm, setPurchaseOrderForm] = useState(formFields);
  const handleCloseModal = () => {
    setShowPurchaseModal(false);
  };
  const handleCloseConfirmModal = () => {
    setShowConfirmModel(false);
  };

  const handleChangePurchaseOrder = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPurchaseOrderForm({ ...purchaseOrderForm, [name]: value });
  };
  const onChangeDocumentOne = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file1: null, file_1: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_1: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };
  const onChangeDocumentTwo = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file2: null, file_2: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_2: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const onChangeDocumentThree = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file3: null, file_3: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_3: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const getPurchaseOrderRequestList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0) => {
    try {
      let condition = {
        item: machineNameSearch || '',
        poNumber: poNumber || '',
      };
      if (localStorage.factoryId) {
        condition['factoryId'] = await localStorage.factoryId;
      } else {
        return {};
      }
      const purchaseOrder = await getPurchaseOrderRequest(offset, limit, condition);

      return {
        data: (purchaseOrder && purchaseOrder.data.rows) || [],
        totalRecords: (purchaseOrder && purchaseOrder.data && purchaseOrder.data.count) || 0,
      };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  async function getPurchase() {
    const data = await getPurchaseOrderRequestList(TABLE_DEFAULT_LIMIT, currentPage - 1);
    const filteredData = data.data.filter((item) => !item.isDeleted);
    setTotalRecords(data.totalRecords);
    setPurchaseOrderList(filteredData);
  }

  useEffect(() => {
    getPurchase();
  }, [currentPage]);

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getPurchase();
      }
    },
    [machineNameSearch, poNumber],
    DEBOUNCE_DELAY
  );

  const handleShowModal = (event, id) => {
    event.preventDefault();
    const getPurchaseOrderRequest = async () => {
      const PurchaseOrderVal = await getPurchaseOrderById(id);
      const hole = PurchaseOrderVal?.data;
      if (hole.approvedDate !== null) hole.approvedDate = moment(hole.approvedDate).format('YYYY-MM-DD');
      hole.file1 = null;
      hole.file2 = null;
      hole.file3 = null;
      delete hole.quotation;
      delete hole.machine_request;
      setPurchaseOrderForm(hole);
    };
    getPurchaseOrderRequest();
    setShowPurchaseModal(true);
  };

  const handleShowConfirmModal = (e, id, machineId) => {
    e.preventDefault();
    setShowConfirmModel(true);
    setIdToDeleted(id);
    setMachineIdToDeleted(machineId);
  };

  const handleRemove = (event, id) => {
    event.preventDefault();
    const deleteMachine = async () => {
      try {
        const data = await deletePurchaseOrder(id);
        toast.error(data.data);
        getPurchase();
        setShowConfirmModel(false);
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 3000 });
      }
    };
    deleteMachine();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      !purchaseOrderForm.poNumber ||
      !purchaseOrderForm.item ||
      !purchaseOrderForm.amount ||
      !purchaseOrderForm.initiatedBy ||
      !purchaseOrderForm.approvedDate ||
      !purchaseOrderForm.file_1 ||
      !purchaseOrderForm.file_2
    ) {
      toast.error('Please fill in all the required fields.');
      return;
    }
    try {
      await editPurchaseOrder(purchaseOrderForm.id, purchaseOrderForm);
      toast.success('Purchase Order updated successfully');
      setShowPurchaseModal(false);
      getPurchase();
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 2000 });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/purchase-orders">Purchase Order List</a>
          </li>
        </ol>
      </nav>
      <div className="card top-card">
        <div className="card-body">
          <div className="row">
            <FactoryDropdown onFactoryChange={getPurchase} />
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">Machine Name</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Please enter Machine Name"
                value={machineNameSearch}
                onChange={(e) => {
                  setMachineNameSearch(e.target.value);
                }}
              />
            </div>
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">PO Number</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Please enter PO Number"
                value={poNumber}
                onChange={(e) => {
                  setPoNumber(e.target.value);
                }}
              />
            </div>
            <div className="form-group col-md-2 col-lg-2">
              <div className="btn-wrapper justify-content-start cmt-3">
                <button
                  type="button"
                  className="btn app-btn-default"
                  onClick={(e) => {
                    setMachineNameSearch('');
                    setPoNumber('');
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          {factoryId_ ? (
            <>
              <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                Purchase Order | {totalRecords ?? 0}
              </h4>
            </>
          ) : (
            <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
              Please Select a Factory
            </h4>
          )}
        </div>
        {factoryId_ && totalRecords > 0 ? (
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>Machine Name</th>
                      <th>PO#</th>
                      <th>Section</th>
                      <th>Amount</th>
                      <th>Approved By</th>
                      <th>Vendor Name</th>
                      <th>Approved Date</th>
                      <th>Created Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchaseOrderList.map((request, index) => {
                      return (
                        <tr key={request.id} className={request.isDeleted ? '' : request.status === 'SCRAP-RESELL' ? 'resell-scrap' : ''}>
                          <td>{request?.item}</td>
                          <td>{request.poNumber}</td>
                          <td>{request.section}</td>
                          <td>{request?.amount}</td>
                          <td>{request.initiatedBy}</td>
                          <td>{request?.quotation?.vendorName}</td>
                          <td>{formatDate(request.approvedDate)}</td>
                          <td>{formatDate(request.createdAt)}</td>
                          <td className="actions">
                            <Link to={`/mm/purchase-orders/${request.id}`}>
                              <ViewIcon />
                            </Link>
                            &nbsp;&nbsp;
                            {request.status !== 'HIDDEN' ? (
                              <span onClick={(e) => handleShowModal(e, request.id)} className="edit-icon">
                                <EditIcon />
                              </span>
                            ) : (
                              ''
                            )}
                            &nbsp;&nbsp;
                            {request.status !== 'HIDDEN' ? (
                              <Link
                                to="/"
                                className="delete"
                                onClick={(e) => handleShowConfirmModal(e, request.id, request.machineRequestId)}
                              >
                                <DeleteIcon />
                              </Link>
                            ) : (
                              ''
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <PaginationInPage
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalRecords={totalRecords}
                  TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            {factoryId_ ? (
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
                  No Data Available
                </h4>
              </div>
            ) : (
              ''
            )}
          </>
        )}
      </div>
      <Modal size="lg" show={showPurchaseModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Edit Purchase Order</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Purchase Number" className="mb-3">
                  <Form.Control
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm?.poNumber}
                    className="input"
                    name="poNumber"
                    type="text"
                    placeholder="Purchase Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                  <Form.Control
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm?.item}
                    className="input"
                    name="item"
                    type="text"
                    placeholder="Machine Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Amount" className="mb-3">
                  <Form.Control
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm?.amount}
                    className="input"
                    name="amount"
                    type="text"
                    placeholder="Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved Date" className="mb-3">
                  <Form.Control
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm?.approvedDate}
                    className="input"
                    name="approvedDate"
                    type="date"
                    placeholder="Approved Date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved By" className="mb-3">
                  <Form.Control
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm?.initiatedBy}
                    className="input"
                    name="initiatedBy"
                    type="text"
                    placeholder="Name of the Approver"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>PO Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeDocumentOne} type="file" name="file_1" aria-required="false" required />
                  <p className="file-name">{purchaseOrderForm?.file_1}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeDocumentTwo} type="file" name="file_2" aria-required="false" required />
                  <p className="file-name">{purchaseOrderForm?.file_2}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 3</Form.Label>
                  <Form.Control onChange={onChangeDocumentThree} type="file" name="file3" aria-required="false" />
                  <p className="file-name">{purchaseOrderForm?.file_3}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Update
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Purchase Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemove(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default PurchaseOrderView;
